import Autocomplete from "@mui/material/Autocomplete";
import React from "react";

import styles from "../../../../Profile.module.css";

import ModalHeader from "../../../../../../components/commons/ModalHeader";
import SaveButton from "../../../../../../components/commons/SaveButton";
import ScrollDivBody from "../../../../../../components/commons/ScrollDivBody";

import { connect } from "react-redux";
import { store } from "../../../../../../redux/store";

import { withTranslation } from "react-i18next";
import HandleApiError from "../../../../../../components/commons/HandleApiError";
import {
  getEnterpriseCodes,
  updateProfileData,
  subscribeToDepartment,
} from "../../../../../../redux/actions/profile";
import { handleSuccessMessage } from "../../../../../../redux/actions/success";
import { EDIT_PROFILE_DATA } from "../../../../../../redux/constants/actionTypes";

class UpdateInstituteCode extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      about: this.props.about,
      edit: false,
      text: this.props.about || "",
      error: false,
      message: "error",
      options: [],
      loading: false,
      selectedId: "",
     };

    this._inputDebounce = null;

    this.ModalHeaderOnClick = this.ModalHeaderOnClick.bind(this);
    this.ScrollBody = this.ScrollBody.bind(this);
    this.SaveButtonOnClick = this.SaveButtonOnClick.bind(this);
    this.changeText = this.changeText.bind(this);
    this._fetchOptions = this._fetchOptions.bind(this);
    this._inputDebounce = null;
  }

  changeText(text) {
    this.setState({ text: text });
  }
  changeEdit(edit) {
    this.setState({ edit: edit });
  }

  ModalHeaderOnClick() {
    this.props.changeEdit(false);
    document.body.style.overflow = "visible";
  }

  SaveButtonOnClick() {
    const { t } = this.props;
    const txt = this.state?.text || "";
    const user = store.getState().profile.user;
    const deptUuid = this.state?.selectedId || "";

    // Validation: allow empty (unset) or length >= 4; reject 1-3 chars
    if (txt.length > 0 && txt.length < 4) {
      this.setState({ error: true, message: t("errors.instituteCodeLength") });
      return;
    }

    // If user typed but didn't pick a suggestion, we need department UUID
    if (txt.length > 0 && !deptUuid) {
      this.setState({
        error: true,
        message:
          t("errors.selectInstituteFromList") || "Please select from suggestions",
      });
      return;
    }
        
    const deptMem = user?.user_id;

    this.props.subscribeToDepartment(deptMem, deptUuid).then((res) => {
      if (res && res.val) {
        this.props.changeEdit();
        document.body.style.overflow = "visible";
        this.props.handleSuccessMessage(t("successMsgs.codeSetSuccessfully!"));
        return;
      }
      this.setState({ error: true, message: "Error!" });
    });
  }

  // Centralized fetch that maps API response -> autocomplete options
  _fetchOptions() {
    if (this._inputDebounce) clearTimeout(this._inputDebounce);

    this._inputDebounce = setTimeout(() => {
      this.setState({ loading: true });
      this.props
        .getEnterpriseCodes()
        .then(() => {
          const raw = this.props.codeSuggestions || [];
          const mapped = raw
            .filter((v) => v && typeof v.code === "string")
            .map((value) => ({
              label: value.code || "",
              id: value.id,
              department: value.department,
            }));
          this.setState({ options: mapped, loading: false });
        })
        .catch(() => {
          this.setState({ options: [], loading: false });
        });
    }, 250);
  }

  ScrollBody() {
    const { t } = this.props;
    return (
      <div>
        <p className={styles.modal_heading}>{t("profile.instituteCode")}</p>
        <br />
        <div
          style={{
            position: "relative",
            justifyContent: "center",
          }}
        >
          <Autocomplete
            id="institute-code-autocomplete"
            freeSolo
            options={this.state.options}
            loading={this.state.loading}
            value={this.state.text ? { label: this.state.text } : null}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.label || ""
            }
            onInputChange={(event, value, reason) => {
              if (reason === "input") {
                this.setState({ text: value, selectedId: "" });
                if (value && value.length >= 1) this._fetchOptions();
                else this._fetchOptions();
              }
            }}
            onChange={(event, value) => {
              if (value) {
                this.setState({
                  text: value.label || "",
                  selectedId: value.id || "",
                });
              } else {
                this.setState({ text: "", selectedId: "" });
              }
            }}
            renderInput={(params) => (
              <div ref={params.InputProps.ref}>
                <input
                  style={{
                    border: "1px solid #5555555A",
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    marginLeft: 20,
                    marginTop: 20,
                    borderRadius: "25px",
                    width: "85%",
                    minHeight: "42px",
                    outline: "none",
                    padding: "0 0 0 20px",
                    marginBottom: 0,
                  }}
                  type="text"
                  {...params.inputProps}
                  placeholder={t("profile.modalPlaceholder.selectYourCode")}
                  value={this.state.text}
                  onChange={(e) => {
                    const v = e.target.value;
                    this.setState({ text: v, selectedId: "" });
                    if (v && v.length >= 1) this._fetchOptions();
                    else this._fetchOptions();
                  }}
                />
              </div>
            )}
          />
        </div>
      </div>
    );
  }
  componentDidMount() {
    this._fetchOptions();
  }
  render() {
    return (
      <div id={styles.template_modal} className={`${styles.modal_wrapper}`}>
        <ModalHeader
          title={this.props.modalTitle}
          onClick={this.ModalHeaderOnClick}
        />

        <ScrollDivBody body={this.ScrollBody} />

        <SaveButton onClick={this.SaveButtonOnClick} />

        <HandleApiError
          error={this.state.error}
          message={this.state.message}
          onClose={() => this.setState({ error: false })}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    deptCode: state?.profile?.deptCode || "",
    user_type: state?.profile?.user?.user_type || "",
    codeSuggestions: state?.profile?.enterprise_codes || [],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateInstituteCode: (action, data) =>
      dispatch(updateProfileData(action, data)),
    getEnterpriseCodes: (query = "") => dispatch(getEnterpriseCodes(query)),
    subscribeToDepartment: (dept_mem, department) =>
      dispatch(subscribeToDepartment(dept_mem, department)),
    handleSuccessMessage: (successMsg) =>
      dispatch(handleSuccessMessage(successMsg)),
  };
}

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(UpdateInstituteCode)
);
